import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

export default function StandarPelayanan() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Layanan Informasi — Standar Pelayanan
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Standar Pelayanan
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <div className="mt-14 grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <h2
              data-testid="standar-title-1"
              className="font-display text-2xl font-semibold leading-snug text-[#0B2440] md:text-4xl"
            >
              Standar Pelayanan Kami
            </h2>
            <p
              data-testid="standar-text-1"
              className="mt-6 text-[15px] leading-relaxed text-slate-600 md:text-base"
            >
              Standar Pelayanan Informasi Publik adalah komitmen pelayanan
              yang akan dilaksanakan oleh LLDIKTI Wilayah VII bagi masyarakat
              yang mengajukan permohonan informasi publik, sesuai dengan
              Prosedur Operasional Standar (POS) yang ditetapkan.
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <figure
              data-testid="standar-photo-card"
              className="overflow-hidden rounded-3xl border border-[#E3EBF3] bg-[#F3F7FB]"
            >
              <img
                src="/standar-pelayanan-foto.jpg"
                alt="Standar Pelayanan Layanan Informasi Publik LLDIKTI Wilayah VII"
                data-testid="standar-photo"
                className="w-full object-cover"
              />
              <figcaption className="border-t border-[#E3EBF3] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
                Standar Pelayanan Layanan Informasi Publik
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </main>

      <section
        data-testid="standar-diagram-section"
        className="border-y border-[#E3EBF3] bg-[#F3F7FB] px-6 py-20 md:px-12 md:py-28"
      >
        <Reveal>
          <h2
            data-testid="standar-title-2"
            className="text-center font-display text-2xl font-semibold leading-snug text-[#0B2440] md:text-4xl"
          >
            Diagram Standar Pelayanan
          </h2>
          <div className="mt-6 flex justify-center">
            <div className="h-1.5 w-20 rounded-full bg-[#E8A33D]" />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <figure
            data-testid="standar-diagram-card"
            className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl border border-[#E3EBF3] bg-white shadow-[0_18px_44px_rgba(11,36,64,0.10)]"
          >
            <img
              src="/standar-pelayanan-diagram.jpg"
              alt="Diagram Standar Pelayanan Layanan Informasi Publik LLDIKTI Wilayah VII"
              data-testid="standar-diagram"
              className="w-full"
            />
          </figure>
        </Reveal>
      </section>

      <Footer compact />
    </div>
  );
}
